import script from "./ProductTruckTyres.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductTruckTyres.vue?vue&type=script&setup=true&lang=ts"

import "./ProductTruckTyres.vue?vue&type=style&index=0&id=5250b670&lang=css"

const __exports__ = script;

export default __exports__